export const PROPERTY_FILTER_KEYS = {
  BEDS: {
    param: "beds",
    type: "string[]",
  },
  MOVE_IN_DATE: {
    param: "moveInDate",
    type: "string",
  },
  BATHS: {
    param: "baths",
    type: "string[]",
  },
  BUDGET: {
    param: "budget",
    type: "string",
  },
};
